import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {
  transform(value: number): string {
    if (!value || value < 0) {
      return '0s'; 
    }

    const minutes = Math.floor(value / 60);
    const seconds = value % 60;

    const minutePart = minutes > 0 ? `${minutes}m ` : '';
    const secondPart = `${seconds}s`;

    return `${minutePart}${secondPart}`.trim();
  }
}